/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

    <v-data-table    :headers="headers"  :items="estudantes" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

       <!--  <v-btn to="/painelclasses" > <v-icon large color="green darken-2">arrow_back</v-icon> </v-btn > -->

                 <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Estudante <span v-if="idclasse===1"> 10ª classe</span>
          <span v-if="idclasse===2"> 11ª classe</span><span v-if="idclasse===3"> 12ª classe</span>
          <span v-if="idclasse===4"> 13ª classe</span>
            </v-toolbar-title>

          <v-divider class="mx-8" inset vertical></v-divider>
            <!--   <v-btn color="primary" dark class="mb-2" v-on="on">New Itemvv</v-btn>-->
            <div class="flex-grow-1"></div>
         <v-row>
        <v-col class="text-center" cols="4" ><v-btn x-large fab dark color="primary" @click="dialog=true">
              <v-icon dark>add</v-icon>
            </v-btn></v-col>
      </v-row>
          <!--  search  -->
<div   v-if="$store.state.hasMessage && cor=='red'" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

          <v-dialog v-model="dialog" max-width="800px">

            <v-card>

              <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col sm="4" cols="12" md="4">

<v-btn text    @click="close"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col sm="7" cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
   Cadastrar   <span v-if="idclasse===1"> 10ª classe</span>
          <span v-if="idclasse===2"> 11ª classe</span><span v-if="idclasse===3"> 12ª classe</span>
          <span v-if="idclasse===4"> 13ª classe</span>
          <v-progress-circular
                v-if="progresso"
                indeterminate
                color="green"
        ></v-progress-circular>
     </v-col>

      <v-col sm="1"  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>

  </v-row>

                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nome"
                        label="Nome"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        required
                        :rules="ruleBI"
                        v-model="editedItem.bi"
                        :label="descricao"
                        v-mask="mascara"
                      ></v-text-field>

                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch   @change="outroDoc()"></v-switch>
                    </v-col>

 <v-col cols="12" md="3">

   <template>

  <v-menu
    ref="menubi"
    v-model="menubi"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.dataemissaobi"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de emissâo do BI"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      max="2025-12-31"
      min="1950-01-01"
      v-model="datebi"
      @change="saveDatebi"
    ></v-date-picker>
  </v-menu>
  </template>
</v-col>

 <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-if="false"
                        v-model="editedItem.pkPessoa"
                        label="chave primaria auto increemente"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>

                    <v-col cols="12" md="4">

                      <v-text-field
                      v-model="editedItem.nomedopai"
                      label="Filho de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.nomedamae"

                        label=" e de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                   <template>

  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.datanascimento"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de nascimento"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
  </template>
    <v-date-picker
      ref="picker"

      v-model="date"
     max="2006-12-31"
      min="1950-01-01"
      @change="saveDate"
    ></v-date-picker>
  </v-menu>
  </template>

                    </v-col>

                  </v-row>

                   <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="proviSelectedForComb"
                        :items="provincias"
                        item-value="idProvicia"
                        item-text="descricao"
                          @change="loadMunicipioComb"

                        chips
                        label="Natural de:"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="municSelectedForComb"
                        :items="municipiosFiltered"
                        item-value="idMunicipio"
                        item-text="descricao"
                        chips
                        label="Municipio"
                      ></v-combobox>
                    </v-col>
                     <v-col cols="12" md="4">
                      <v-combobox
                        v-model="editedItem.sexo"
                        :rules="ruleRequired"
                        item-value="idSexo"
                        item-text="descricao"
                        :items="dropdowSexo"
                        chips
                        label="Sexo"
                      ></v-combobox>
                    </v-col>

                  </v-row>
                   <v-row>

   <v-col cols="12" md="4">
                      <v-combobox
                              v-if="true"
                                v-model="editedItem.curso"
                                :rules="ruleRequired"
                                item-value="idCurso"
                                item-text="descricao"
                                  @change="loadTurmaComb"
                                :items="cursos"
                                chips
                                label="Curso"
                      ></v-combobox>

                    </v-col>

<v-col cols="12" md="4">

                      <v-combobox  id="turma"
                      v-if="true"
                        v-model="editedItem.turma"
                        :rules="ruleRequired"
                        :value="undefined"
                        item-value="idTurma"
                        item-text="turmadescricao"
                        :items="turmasFiltered"
                        chips
                        label="Turma"
                      ></v-combobox>
                    </v-col>
                  <v-col cols="12" md="4">
                      <v-text-field
                      :rules="ruleRequired"
                      v-model="editedItem.matricula"
                       label="Processo Nº">
                       </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                      <v-text-field
                      v-model="editedItem.telefone"
                       label="Telefone">
                       </v-text-field>
                  </v-col>

 </v-row>

                </v-container>
              </v-card-text>

</v-form>

            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
        <v-icon small @click="deleteItem(item)">delete</v-icon>
      </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->

     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>

  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    datebi: null,
    date: null,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: true,
    turmasAll: [],
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],

    searchInDb: '',
    estudantes: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Turma', value: 'turma' },
      { text: 'Bi', value: 'bi' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      // eslint-disable-next-line no-dupe-keys
      bi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      matricula: ''
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null,
      matricula: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    if (!this.$store.state.idclasse) { this.$router.push('/painelclasses') }

    // this.CarregActividades()
    // this.initialize()
    this.initializeProvincias()
    this.initializeMunicipiosAll()
    this.initializeCursos()
    this.initializeturmasAll()
  },

  methods: {
    async initialize (searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"all"}'
        } else {
          // eslint-disable-next-line no-redeclare
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"' + searchInDb + '"}'
        }

        this.isLoading = true
        this.estudantes = await axios
          .get('/estudanteFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          value => (value.length >= 16) && (value.length <= 30 || 'Minimo de caracteres exigido( 16 )')
        ]
      }
    },

    loadTurmaComb () { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    chamaDialogo () {
      this.dialog = true
    },

    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkPessoa)
      // this.estudantes.splice(index, 1)
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save () {
      if (this.$refs.form.validate()) {
        // Check the student´s age , less than 14 won´t be allowed to study on high school
        let ano_nascimento = this.editedItem.datanascimento.toString().split('-')[0]
        if ((this.ano_actual - ano_nascimento) >= 14) {
          this.progresso = true

          const ls = require('local-storage')
          var params = {
            pkPessoa: this.editedItem.pkPessoa,
            idPEssoa: this.editedItem.bi,
            idMunicipio: this.municSelectedForComb.idMunicipio,
            idPerfil: 1,
            nome: this.editedItem.nome,
            morada: this.editedItem.morada,
            telefone: this.editedItem.telefone,
            autor: ls.get('idPessoa'),
            datanascimento: this.editedItem.datanascimento,
            data_: this.editedItem.data_,
            status_2: this.editedItem.status_2,
            email: this.editedItem.email,
            sexo: 'M',
            nomedopai: this.editedItem.nomedopai,
            nomedamae: this.editedItem.nomedamae,
            dataemissaobi: this.editedItem.dataemissaobi,
            bi: this.editedItem.bi,
            ResidenteEm: 1,
            instituicao: ls.get('i_id'),
            instituicaodescricao: this.editedItem.instituicaodescricao,
            curso: this.editedItem.curso,
            turma: this.editedItem.turma,
            anolectivo: ls.get('anolectivo'),
            idanolectivo: ls.get('idanolectivo'),
            idanoacademico: this.idclasse,
            matricula: this.editedItem.matricula
          }

          let estudanteCadastrado = {
            nome: params.nome,
            turma: params.turma.idTurma,
            bi: params.bi,
            matricula: this.editedItem.matricula
          }
          try {
            let cor_mensagem = 'msgError'
            let msg = await axios
              .post('/estudanteKilambaInsertOrUpdate', params)
              .then(res => res.data)
            // this.text = msg[1].insertId
            if (msg === 'Inserção ou Actualização feita com sucesso') {
              cor_mensagem = 'msgSucess'
              // Insere na coleção
              this.estudantes.unshift(estudanteCadastrado)
              this.Limpar()
            }
            if (msg === 'Número de Bi ja existente') {
              cor_mensagem = 'msgError'
            } else
            if (msg === 'Matricula ja existente') {
              cor_mensagem = 'msgError'
            } else
            if (msg === 'Ocorreu um erro ao inserir') {
              cor_mensagem = 'msgError'
            }
            this.text = msg
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': cor_mensagem, 'timeout': 8000 })
            this.progresso = false

            //  this.close();
          } catch (error) {
            this.isLoading = false
            this.progresso = false
            this.text = error.message
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          }
        } else {
          this.text = "O estudante tem a idade( '" + (this.ano_actual - ano_nascimento) + "' anos ) inferior a permitida pelo sistema.( Idade minima 14 anos )"
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        }
      }
    },

    Limpar () {
      this.editedItem.nome = ''
      this.editedItem.bi = ''
      this.editedItem.datanascimento = ''
      this.editedItem.nomedopai = ''
      this.editedItem.nomedamae = ''
      this.editedItem.dataemissaobi = ''
      this.editedItem.telefone = ''
    },

    async delete (idv) {
      try {
        var msg = await axios
          .get('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        this.text = error.message
      } finally {

      }
    }
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
